import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import { useTranslation } from 'react-i18next';
import Modal from '../../../_ui/Modal/Modal';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';

export default function ReceivedVoucherInfoModal({ row, open, onClose, lang }) {
  const { t } = useTranslation();
  const info = row['_original'];
  console.log(info);
  return (
    <Modal open={open} onClose={onClose} title={t('receivedVoucher_modalTitle')}>
      <DialogContent className="disable">
        <Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={info?.id ?? ''}
              label={t('receivedVoucher_kindergartenVoucherQueueId')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={`${moment(info?.createdAt).format('DD.MM.YYYY')}  ${moment(
                info?.createdAt
              ).format('HH:mm:ss')}`}
              label={t('receivedVoucher_receiveDate')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={info?.childIin ?? ''}
              label={t('receivedVoucher_childIin')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={`${info?.childSurname || ''} ${info?.childName ||
              ''} ${info?.childMiddleName || ''}`}
              label={t('receivedVoucher_childFullName')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={
                lang === 'ru'
                  ? info.ageGroup?.ru_name
                  : info.ageGroup?.kk_name
              }
              label={t('receivedVoucher_userCategory')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={
                lang === 'ru'
                  ? info.queuedType?.ru_name
                  : info.queuedType?.kk_name
              }
              label={t('receivedVoucher_queuedType')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={`${moment(info?.arriveDeadline).format('DD.MM.YYYY')}  ${moment(
                info?.arriveDeadline
              ).format('HH:mm:ss')}`}
              label={t('receivedVoucher_arriveDeadline')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={
                lang === 'ru'
                  ? info.appStatusWebStatus?.ru_name
                  : info.appStatusWebStatus?.kk_name
              }
              label={t('receivedVoucher_status')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={info?.bulletinId ?? ''}
              label={t('receivedVoucher_bulletinId')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={lang === 'ru' ? info.queuedRegion?.ru_name : info.queuedRegion?.kk_name}
              label={t('receivedVoucher_serviceProviderLocation')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={info?.serviceProviderBin ?? ''}
              label={t('receivedVoucher_serviceProviderBin')}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Modal>
  );
}
